type GraphqlMutationResult<TData> = {
  data?: TData | null;
  errors?: readonly { message?: string | null }[];
};

export const requireMutationData = <TData, TSelected>(
  result: GraphqlMutationResult<TData>,
  selectData: (data: TData | null | undefined) => TSelected | null | undefined,
  fallbackMessage: string
): TSelected => {
  const errorMessage = result.errors?.map((error) => error.message).filter(Boolean).join('\n');
  if (errorMessage) {
    throw new Error(errorMessage);
  }

  const selectedData = selectData(result.data);
  if (!selectedData) {
    throw new Error(fallbackMessage);
  }

  return selectedData;
};

export const getErrorMessage = (error: unknown, fallbackMessage: string): string => {
  const graphQLErrors = (error as { graphQLErrors?: readonly { message?: string | null }[] })?.graphQLErrors;
  const graphQLErrorMessage = graphQLErrors?.map((graphQLError) => graphQLError.message).filter(Boolean).join('\n');
  if (graphQLErrorMessage) {
    return graphQLErrorMessage;
  }

  if (error instanceof Error) {
    return error.message;
  }

  if (typeof error === 'string' && error.trim()) {
    return error;
  }

  return fallbackMessage;
};
